import { useTranslation } from "hhn-commons";
import { useState } from "react";
import { SearchBoxWrapper } from "../commonHeader/GroupHeader.style";
import { SearchBox } from "../../../common/SearchBox";
import { IconButton } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { IMessageListFilter } from "@home-health-notify/domain";

export const PrivateMessageSearch = ({
  onClearSearch,
  onFilter,
  fullWidth = false,
}: {
  onClearSearch: () => void;
  onFilter: (filters: IMessageListFilter) => void;
  fullWidth?: boolean;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  const [searchText, setSearchText] = useState("");
  const [filterRequest, setFilterRequest] = useState<IMessageListFilter>({});
  const [isSearchLoading, setSearchLoading] = useState(false);

  const handleSearch = (inputVal: IMessageListFilter) => {
    setSearchLoading(true);
    onFilter(inputVal);
    setSearchLoading(false);
  };

  const onSearchTextChange = (text: string) => {
    setSearchText(text);
    const clonedChatListFilter: IMessageListFilter = {
      search: text,
    };
    setFilterRequest(clonedChatListFilter);
    handleSearch(clonedChatListFilter);
  };

  const onSearchClear = () => {
    setSearchText("");
    let clonedFilterRequest = { ...filterRequest };
    delete clonedFilterRequest["search"];
    setFilterRequest(clonedFilterRequest);
    onClearSearch();
  };

  return (
    <SearchBoxWrapper
      data-testid="MessageSearchContainer"
      fullWidth={fullWidth}
    >
      <SearchBox
        placeholderLabel={tNs("search.placeholder")}
        searchText={searchText}
        onSearchClear={onSearchClear}
        onSearchTextChange={onSearchTextChange}
        isLoading={isSearchLoading}
      >
        <IconButton data-testid="SearchOff" onClick={onClearSearch}>
          <SearchOffIcon color={"primary"} />
        </IconButton>
      </SearchBox>
    </SearchBoxWrapper>
  );
};
